






























































































































































import {
  computed,
  defineComponent, reactive, Ref, ref, onMounted,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import {
  getPurchaseRequests,
  updatePurchaseRequest,
  getJobs,
  getPurchaseRequestStats,
} from '@/api';
import purchaseRequestTableOption from '@/table/PurchaseRequest/purchase-request';
import usePurchaseRequest from '@/use/usePurchaseRequest';
import useAuth from '@/use/useAuth';
import useDownloadReport from '@/use/useDownloadReport';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonModalWithPurchaseRequestInfo from '@/components/PurchaseRequest/CommonModalWithPurchaseRequestInfo.vue';
import PanelWithMaterialPurchaseRequestEditor from '@/components/PurchaseRequest/PanelWithMaterialPurchaseRequestEditor.vue';

const List = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonModalWithPurchaseRequestInfo,
    PanelWithMaterialPurchaseRequestEditor,
  },
  setup(props, { root }) {
    const { router } = useRouter();
    const { en: statusList, th: statusDisplay } = usePurchaseRequest();
    const toCurrencyWithoutSign = (amount: number): string => (amount || 0).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const { getCSVReport } = useDownloadReport();
    const viewPurchaseRequestModal = ref(null);
    const cancelPrModal = ref(null);
    const refetchQuery = ref(false);

    const { hasPermission: checkPermissionHandler } = useAuth();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }

    const pendingSearch = _.debounce(() => {
      refetchQuery.value = true;
    }, 250);
    const stats = reactive({
      total: 0,
      pending: 0,
      done: 0,
    });

    async function getStats() {
      const result = await getPurchaseRequestStats();
      if (result !== null) {
        stats.total = result.data.total || 0;
        stats.pending = result.data.pending || 0;
        stats.done = result.data.done || 0;
      }
    }

    onMounted(async () => {
      await getStats();
    });

    const purchaseRequestTableResult = (data: any) => data.data;
    const filter = reactive({
      searchString: '',
      status: '',
      job_no: '',
      po_code: '',
      dateFrom: undefined,
      dateTo: undefined,
      approved: undefined,
    });
    function clickDateHandler(date: any) {
      if (filter.dateFrom === useFormat.date(date).computerShortDate()) {
        filter.dateFrom = undefined;
        filter.dateTo = undefined;
      } else {
        filter.dateFrom = useFormat.date(date).computerShortDate();
        filter.dateTo = useFormat.date(date).computerShortDate();
      }
      pendingSearch();
    }
    const computedFilter = computed(() => {
      const output: { [key: string]: any } = {
        code: filter.searchString,
        job_no: filter.job_no,
        po_code: filter.po_code,
        transactionDate: filter.dateFrom,
        approved: filter.approved,
      };
      if (filter.status === 'DONE') {
        output.hasPo = true;
        output.status = filter.status;
      } else output.status = filter.status;
      return output;
    });

    const onRowClick = (row: { item: { id: number } }) => {
      (viewPurchaseRequestModal.value as any).open(row.item.id);
    };

    const selectedMaterial = ref(null);

    const materialPurchaseRequestEditor = ref(null);

    async function updatePurchaseRequestStatusHandler(ctx: any) {
      await updatePurchaseRequest(ctx.id, { status: ctx.status });
      refetchQuery.value = true;
    }

    const exportCSVModal = ref(null);
    const availableSelectStatus = ['', 'PENDING', 'DONE', 'CANCELLED'];
    const availableSelectStatusDisplay = ['กรองสถานะ', 'รอสั่งซื้อ', 'เสร็จสิ้น', 'ยกเลิก'];
    const csvReportVariables = reactive({
      selectedPurchaseRequests: [],
      selectedJobs: [],
      approved: undefined,
      status: '',
      range: {
        from: undefined,
        to: undefined,
      },
    });
    function clearCSVReportFilter() {
      csvReportVariables.selectedPurchaseRequests = [];
      csvReportVariables.selectedJobs = [];
      csvReportVariables.approved = undefined;
      csvReportVariables.status = '';
      csvReportVariables.range = {
        from: undefined,
        to: undefined,
      };
    }
    function exportCSVReport() {
      const variables = {
        ids: csvReportVariables.selectedPurchaseRequests.map((itm: any) => itm.id),
        boms: csvReportVariables.selectedJobs.map((itm: any) => itm.id),
        from: undefined,
        to: undefined,
        status: undefined,
      };
      if (csvReportVariables.range.from) {
        variables.from = csvReportVariables.range.from;
        variables.to = csvReportVariables.range.to;
      }
      if (csvReportVariables.status) {
        variables.status = csvReportVariables.status as any;
      }

      getCSVReport('purchase_requests', 'csv', 'purchase_request', variables);
      clearCSVReportFilter();
    }

    return {
      getCSVReport,
      toCurrencyWithoutSign,

      statusList,
      statusDisplay,
      stats,
      filter,
      computedFilter,
      clickDateHandler,
      hasPermission,
      purchaseRequestTableOption,
      getPurchaseRequests,
      purchaseRequestTableResult,
      onRowClick,
      viewPurchaseRequestModal,

      updatePurchaseRequestStatusHandler,
      cancelPrModal,

      selectedMaterial,

      materialPurchaseRequestEditor,

      pendingSearch,
      refetchQuery,

      getJobs,
      exportCSVModal,
      availableSelectStatus,
      availableSelectStatusDisplay,
      csvReportVariables,
      exportCSVReport,
      clearCSVReportFilter,
    };
  },
});

export default List;
